import { createIcon } from '../createIcon.tsx';

/** Ruled table: a header row plus one column divider. Distinct from `GridIcon` (four detached tiles) and `CalendarIcon` (two hanger ticks, no column rule). */
export const TableIcon = createIcon(
	'TableIcon',
	<>
		<rect x="2" y="3" width="20" height="18" rx="2" />
		<line x1="2" y1="9" x2="22" y2="9" />
		<line x1="9" y1="21" x2="9" y2="9" />
	</>,
);
